<a class="menu-title" (click)="openNotificationPopup($event)" *ngIf="hasLoggedIn">
  <span class="lp-icon"><i class="fas fa-bell"></i></span>
  <span class="lp-text">Thông báo</span>
  <span class="badge badge-pill badge-warning" style="margin-left: 4px;">
    {{ notificationData.totalNotRead < 20 ? notificationData.totalNotRead : '20+' }}
  </span>
</a>
<div id="notification-popup" [ngClass]="{'show': isShowPopup}" appClickOutside (clickOutside)="closePopup()">
  <ul *ngIf="notificationData && notificationData.items && notificationData.items.length > 0" class="notification-list" style="display: block !important;">
    <li class="notification-item" *ngFor="let notification of notificationData.items" 
        [ngClass]="{'notification-read': notification.isRead}"
        (click)="onNotificationClick(notification)">
      <div class="notification-title">{{notification.title}}</div>
      <div class="notification-content">{{notification.body}}</div>
      <div class="notification-date">{{ notification.creationTime | date: 'HH:mm dd/MM/yyyy' }}</div>
    </li>
  </ul>
</div>
